import classNames from "classnames";
import styles from "./index.module.css";
import type { FC } from "react";

export type PagerProps = {
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
  totalPage?: number;
  currentPage?: number;
  numOfItems?: number;
  onNavigation?: (page: number) => void;
};

// startとendを指定するとその範囲の数字の配列を返す関数
// 例: range(2, 4) => [2, 3, 4]
const range = (start: number, end: number) =>
  Array.from({ length: end - start + 1 }, (_, i) => start + i);

export const Pager: FC<PagerProps> = ({
  currentPage = 1,
  totalPage = 1,
  numOfItems = 5,
  hasPreviousPage = false,
  hasNextPage = false,
  onNavigation = () => {},
}) => {
  // 総数から現在のページ(=1個)を引いて / 2 とすることで、左右にいくつ要素が存在しうるかを取得する。
  const halfNumOfItems = Math.floor((numOfItems - 1) / 2);

  const pages = () => {
    // 最初の方のページの場合
    if (currentPage - halfNumOfItems <= 1) {
      return range(1, totalPage).splice(0, numOfItems);
      // 最後の方のページに近い場合
    } else if (currentPage + halfNumOfItems >= totalPage) {
      return range(totalPage - numOfItems, totalPage).splice(
        -numOfItems,
        numOfItems
      );
    } else {
      return range(currentPage - halfNumOfItems, currentPage + halfNumOfItems);
    }
  };

  return (
    <ul className={classNames(styles.pager, "c-pager c-pager-list")}>
      <li
        className={classNames(
          styles.item,
          "arrow arrow-prev",
          !hasPreviousPage && "hidden"
        )}
        onClick={(e): void => {
          e.preventDefault();
          hasPreviousPage && onNavigation(currentPage - 1);
        }}
      >
        <a className={styles.prev} href="" />
      </li>

      {pages()
        .filter((p) => p > 0)
        .map((i) => (
          <li key={i} className={styles.item}>
            {i === currentPage ? (
              <span className={classNames(styles.current, "active")}>{i}</span>
            ) : (
              <a
                className={classNames(styles.link)}
                onClick={(e): void => {
                  e.preventDefault();
                  onNavigation(i);
                }}
              >
                {i}
              </a>
            )}
          </li>
        ))}

      <li
        className={classNames(
          styles.item,
          "arrow arrow-next",
          !hasNextPage && "hidden"
        )}
        onClick={(e): void => {
          e.preventDefault();
          hasNextPage && onNavigation(currentPage + 1);
        }}
      >
        <a className={styles.next} href="" />
      </li>
    </ul>
  );
};

export default Pager;
